<template>
  <div class="marketCatalog">
    <AvailableProducts @clickedBuy="onBuy"/>
  </div>
</template>

<script>
import AvailableProducts from '@/components/market/AvailableProducts'
import MarketPaymentModal from '@/components/market/payment/MarketPaymentModal'


export default {
  components: {
    AvailableProducts,
  },
  methods: {
    async onBuy(productId) {
      this.selectedProductId = productId;
      this.show_modal = true;
    },
  },
}
</script>

<style lang="scss" scoped>
.marketCatalog {
  padding-left: 20px;
}
</style>